
import s from './client_status/state'
import * as a from './client_status/actions'
import * as m from './client_status/mutations'
import * as g from './client_status/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
